import { render } from "./HighAvailability.vue?vue&type=template&id=c99d7d76"
import script from "./HighAvailability.vue?vue&type=script&lang=js"
export * from "./HighAvailability.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__